const FeeTaxTypeEnum = Object.freeze({
    EIS: 'EIS',
    SEIS: 'SEIS',
    IHT: 'IHT',
    VCT: 'VCT',
    PMI: 'PMI'
});

export default FeeTaxTypeEnum;
